import Api from '/api'

export default class Statistics {}

Statistics.api = function (socket) {
  return new Api(socket, 'statistics')
}